// extracted by mini-css-extract-plugin
module.exports = {"rightColumn":"RightColumn_rightColumn__qK4O2","shadow":"RightColumn_shadow__TULDC","border":"RightColumn_border__czw2P"};